import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const ItDocumentModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 5C5 3.89543 5.89543 3 7 3H14C16.7614 3 19 5.23858 19 8V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V5Z"
            fill="url(#paint0_linear_123_14398)"
          />
          <path
            d="M7 9.5C7 9.22386 7.22386 9 7.5 9H14.5C14.7761 9 15 9.22386 15 9.5C15 9.77614 14.7761 10 14.5 10H7.5C7.22386 10 7 9.77614 7 9.5Z"
            fill="#341896"
          />
          <path
            d="M7 6.5C7 6.22386 7.22386 6 7.5 6H10.5C10.7761 6 11 6.22386 11 6.5C11 6.77614 10.7761 7 10.5 7H7.5C7.22386 7 7 6.77614 7 6.5Z"
            fill="#341896"
          />
          <path
            d="M19 7.7619C19 7.8934 18.8934 8 18.7619 8L16 8C14.8954 8 14 7.10457 14 6L14 3.23809C14 3.1066 14.1066 3 14.2381 3C16.868 3 19 5.13198 19 7.7619Z"
            fill="url(#paint1_linear_123_14398)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 13H8V18H16V13ZM8 12C7.44772 12 7 12.4477 7 13V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V13C17 12.4477 16.5523 12 16 12H8Z"
            fill="#341896"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 15V12.5H14V15H16V16H14V18.5H13V16H8V15H13Z"
            fill="#341896"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_14398"
              x1="12"
              y1="3"
              x2="12"
              y2="21"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A680FF" />
              <stop offset="1" stop-color="#17FF6D" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_14398"
              x1="14.5"
              y1="9"
              x2="18.7782"
              y2="2.35715"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#ADB9F7" />
              <stop offset="1" stop-color="#17FF6D" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default ItDocumentModule;
